import {CalendarSpec, Moment} from 'moment';
import {MomentLanguageCode} from '../enums/moment-language-code';

// Calendars
export const getCalendar = (date: Moment, locale: string): CalendarSpec => {
  if (locale === MomentLanguageCode.enGB) {
    return {
      sameDay: '[Today]',
      nextDay: '[Tomorrow]',
      nextWeek: 'dddd',
      lastDay: '[Yesterday]',
      lastWeek: '[Last] dddd',
      sameElse: 'L',
    };
  } else if (locale === MomentLanguageCode.esES) {
    return {
      sameDay: '[Hoy]',
      nextDay: '[Mañana]',
      nextWeek: 'dddd',
      lastDay: '[Ayer]',
      lastWeek: '[El] dddd [pasado]',
      sameElse: 'L',
    };
  } else if (locale === MomentLanguageCode.glES) {
    return {
      sameDay: '[Hoxe]',
      nextDay: '[Mañá]',
      nextWeek: 'dddd',
      lastDay: '[Onte]',
      lastWeek: '[O] dddd [pasado]',
      sameElse: 'L',
    };
  } else {
    // In Portuguese, the days of the week have different genders.
    // To know which gender to use, we'll have to get the day of the week before hand.
    // We did the following in the past:
    /* lastWeek: (m?: MomentInput) => {
        return (m as Moment)?.day() === 0 || (m as Moment)?.day() === 6
          ? '[Último] dddd' // Saturday + Sunday
          : '[Última] dddd'; // Monday - Friday
      } */
    // But "m" was always returning the current date.

    // Get the day
    // Note: Sunday as 0 and Saturday as 6
    const day: number = date.day();

    // Set the right calendar
    if (day === 0 || day === 6) {
      return {
        sameDay: '[Hoje]',
        nextDay: '[Amanhã]',
        nextWeek: 'dddd',
        lastDay: '[Ontem]',
        lastWeek: '[Último] dddd',
        sameElse: 'L',
      };
    } else {
      return {
        sameDay: '[Hoje]',
        nextDay: '[Amanhã]',
        nextWeek: 'dddd',
        lastDay: '[Ontem]',
        lastWeek: '[Última] dddd',
        sameElse: 'L',
      };
    }
  }
};
